import AboutSideBar from "../components/AboutSideBar";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import InfoPanel from "../components/InfoPanel";
import "../styles/about.css";
import AboutLeftTabs from "../components/AboutLeftTabs";
import Panel from "../components/Panel";
import { FilterProvider } from "../context/FilterContext";
import { Helmet } from "react-helmet";

const About = () => {
  return (
    <>
      <Helmet>
        <title>_about-me | Mert Arinci | Full-Stack Developer</title>
        <meta
          name="description"
          content="Learn about Mert Arinci's journey as a Full-Stack Developer. 29 years old, based in Rotterdam, Netherlands. Passionate about coding, modern technologies, and building scalable web applications."
        />
        <meta
          name="keywords"
          content="About Mert Arinci, Developer Biography, Skills, Experience, Rotterdam Developer, JavaScript Expert"
        />
        <link rel="canonical" href="https://arinci.nl/about" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="_about-me | Mert Arinci | Full-Stack Developer"
        />
        <meta
          property="og:description"
          content="Learn about Mert Arinci's journey as a Full-Stack Developer. Based in Rotterdam, Netherlands. Passionate about modern technologies and scalable web applications."
        />
        <meta property="og:type" content="profile" />
        <meta property="og:url" content="https://arinci.nl/about" />
        <meta property="og:site_name" content="Mert Arinci Portfolio" />
        <meta
          property="og:image"
          content="https://arinci.nl/og-image-about.jpg"
        />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="About Me - Mert Arinci | Full-Stack Developer"
        />
        <meta
          name="twitter:description"
          content="Learn about Mert Arinci's journey as a Full-Stack Developer. Based in Rotterdam, Netherlands."
        />

        <meta name="robots" content="index, follow" />

        {/* JSON-LD Structured Data for About Page */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            mainEntity: {
              "@type": "Person",
              name: "Mert Arinci",
              age: 29,
              jobTitle: "Full-Stack Developer",
              description:
                "Passionate Full-Stack Developer with expertise in modern web technologies",
              address: {
                "@type": "PostalAddress",
                addressLocality: "Rotterdam",
                addressCountry: "Netherlands",
              },
              hasOccupation: {
                "@type": "Occupation",
                name: "Full-Stack Developer",
                skills: [
                  "JavaScript",
                  "React",
                  "Node.js",
                  "TypeScript",
                  "HTML",
                  "CSS",
                  "MongoDB",
                  "SQL",
                  "Python",
                  "Express",
                  "Next.js",
                  "Git",
                  "Agile",
                ],
              },
            },
          })}
        </script>
      </Helmet>
      <FilterProvider>
        <div id="about-me">
          <Navbar activePage={"about"} />
          <div className="about-content">
            <AboutLeftTabs />
            <AboutSideBar />
            <Panel />
            <InfoPanel />
          </div>
          <Footer />
        </div>
      </FilterProvider>
    </>
  );
};

export default About;
